/* eslint-disable react/button-has-type */
import React, { useRef, useState,useEffect } from "react";
import attachIcon from "../../../assets/logos/Attach.svg";
import sendIcon from "../../../assets/logos/send.svg";

const AgentFooter = ({ onSendMessage, isAgentPanelOpen, disabled }) => {
  const [text, setText] = useState("");

  const handleSend = () => {
    if (!text.trim()) return;
    onSendMessage(text);

    setText("");
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";     // reset height
      textareaRef.current.style.overflowY = "hidden";
    }

  };
    const textareaRef = useRef(null);

  useEffect(() => {
    if (isAgentPanelOpen) {
      textareaRef.current?.focus();
    }
  }, [isAgentPanelOpen]);



  const handleInput = (e) => {
    setText(e.target.value);

    const el = textareaRef.current;
    el.style.height = "auto";

    if (el.scrollHeight <= 500) {
      el.style.height = el.scrollHeight + "px";
    } else {
      el.style.height = "500px";
    }
  };

  return (
    <div className="agent-footer">

      <div className="input-wrapper">
        <textarea
          ref={textareaRef}
          type="text"
          placeholder="Ask me anything..."
          className="agent-input"
          id="textareaInput"
          rows={1}
          value={text}
          onChange={handleInput}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey && !disabled) {
              e.preventDefault();
              handleSend();
            }
          }}
        />

        <div className="right-icons">
          {/* <img src={attachIcon} alt="attach" className="attach-icon" /> */}

          <button className="send-icon" onClick={handleSend} disabled={!text.trim() || disabled}>
            <img src={sendIcon} alt="sendIcon" className="sendIcon" />
          </button>
        </div>
      </div>

    </div>
  );
};

export default AgentFooter;
